import { render, staticRenderFns } from "./ExclusionCard.vue?vue&type=template&id=359b06c6&"
import script from "./ExclusionCard.vue?vue&type=script&lang=ts&"
export * from "./ExclusionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports